/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { Radio, RadioGroup } from '@material-ui/core'

import ShowModal from '@monorepo-amais/commons/components/Modal'

import logo from '@monorepo-amais/commons/assets/img/logo.png'

import useStateWithLocalStorage from './useStateWithLocalStorage'
import { getHrefByRegion } from '../../utils/region'
import SvgCheckedIcon from '../Icons/checkedIcon'

const ModalContainer = styled.div`
	margin: 0 20px;
	font-family: 'fs_lolaregular' !important;

	.infoText {
		p {
			color: #848484;
			font-style: normal;
			font-weight: 400;
			font-size: 16px;
			line-height: 24px;

			strong {
				color: #595959;
				font-weight: 700;
				font-size: 18px;
				line-height: 24px;
			}
		}
	}
`

const OptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	margin-left: 8px;
	border-top: 1px solid #e0e0e0;

	:first-child {
		border: none !important;
	}

	p {
		font-family: 'fs_lolaregular';
		color: #757575 !important;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
		cursor: pointer;
	}

	.Mui-checked {
		color: ${props => props.theme.colors.primary} !important;
	}

	.MuiRadio-root {
		color: ${props => props.theme.colors.primary} !important;
	}
`

const Logo = styled.img`
	margin: 0 auto;
	height: 61px;
`
const Submit = styled.button`
	background: ${props => props.theme.colors.primary};
	height: 50px;
	line-height: 50px;
	border-radius: 50px;
	margin: 32px 0;
	width: 100%;
	border: none;
	color: ${props => props.theme.colors.white};
	font-family: 'fs_lolaregular';
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	cursor: pointer;

	&:disabled {
		background-color: #999999;
		color: ${props => props.theme.colors.white};
		border-color: #999999;
	}
`

const SelectStateNew = ({ modal, regionais, baseLink, show, setShow, theme }) => {
	//console.log('regionais', regionais)
	//console.log('modal', modal)
	const [option, setOption] = useStateWithLocalStorage() //option from LocalStorage
	const [tempOption, setTempOption] = React.useState() //temporario
	const [href, setHref] = React.useState('') //temporario

	if (option) {
		setShow(false)
	} else {
		setShow(true)
	}

	const options = useMemo(
		() =>
			regionais?.metadata.telefones
				.filter(x => x.sigla !== 'ba' && x.sigla !== 'rj' && x.sigla !== 'df')
				.map(obj => ({
					label: obj.estado,
					value: obj.sigla,
					id: `select-option-state-${obj.sigla}`
				})),
		[regionais]
	)

	useEffect(() => {
		getHrefByRegion(window.location.origin, tempOption?.value, window.location.pathname).then(({ href }) =>
			setHref(href)
		)
	}, [tempOption])

	useEffect(() => {
		const firstAccessSection = sessionStorage.getItem('first-access-section')

		if (!firstAccessSection) {
			setShow(true)
			sessionStorage.setItem('first-access-section', true)
		}
	}, [])

	return (
		<ShowModal show={show}>
			<ModalContainer>
				<Logo src={logo} />
				<div className='infoText' dangerouslySetInnerHTML={{ __html: modal?.metadata.modal_texto }} />
				<RadioGroup>
					{options
						.sort((a, b) => b.value - a.value)
						.map(x => (
							<OptionContainer key={x.sigla} onClick={() => setTempOption(x)}>
								<Radio
									className={tempOption ? (tempOption?.value === x.value ? 'selected' : '') : ''}
									key={x.sigla}
									value={x.value}
									id='submit-state-start-app'
									onClick={() => setTempOption(x)}
									checked={tempOption?.value === x.value}
									checkedIcon={<SvgCheckedIcon />}
								/>
								<p> {x.label} </p>
							</OptionContainer>
						))}
				</RadioGroup>

				<a href={href.replace('undefined', 'sp')}>
					<Submit
						id='submit-state-start-app'
						onClick={() => setOption(tempOption)}
						disabled={!tempOption || href === '' || href.includes('undefined')}
					>
						Continuar
					</Submit>
				</a>
			</ModalContainer>
		</ShowModal>
	)
}

export default SelectStateNew

// ***********  Backup Componentes versão antiga  ***********
// const Options = styled.button`
// 	background: ${props => props.theme.colors.white};
// 	height: 50px;
// 	border-radius: 50px;
// 	margin: 10px 0;
// 	width: 100%;
// 	border: 1px solid ${props => props.theme.colors.primary};
// 	color: ${props => props.theme.colors.primary};
// 	font-style: normal;
// 	font-weight: 700;
// 	font-family: 'fs_lolabold';
// 	font-size: 15px;
// 	line-height: 28px;
// 	text-align: center;
// 	cursor: pointer;

// 	&.selected {
// 		color: ${props => props.theme.colors.white};
// 		background: ${props => props.theme.colors.primary};
// 	}
// `
// const Submit = styled.button`
// 	background: ${props => props.theme.colors.white};
// 	height: 50px;
// 	line-height: 50px;
// 	border-radius: 50px;
// 	margin: 10px 0;
// 	width: 100%;
// 	border: none;
// 	color: ${props => props.theme.colors.primary};
// 	font-family: 'fs_lolabold';
// 	font-size: 15px;
// 	font-weight: 600;
// 	text-align: center;
// 	cursor: pointer;

// 	&:disabled {
// 		/* background-color: #999999; */
// 		/* color: ${props => props.theme.colors.white}; */
// 		color: #999999;
// 		/* border-color: #999999; */
// 	}
// `

// return (
// 	<ShowModal show={show}>
// 		<ModalContainer>
// 			<Logo src={logo} />
// 			<div className='infoText' dangerouslySetInnerHTML={{ __html: modal?.metadata.modal_texto }} />
// 			{options
// 				.sort((a, b) => b.value - a.value)
// 				.map(x => (
// 					<Options
// 						className={tempOption ? (tempOption?.value === x.value ? 'selected' : '') : ''}
// 						key={x.sigla}
// 						id='submit-state-start-app'
// 						onClick={() => setTempOption(x)}
// 					>
// 						{x.label}
// 					</Options>
// 				))}

// 			<a href={href.replace('undefined', 'sp')}>
// 				<Submit
// 					id='submit-state-start-app'
// 					onClick={() => setOption(tempOption)}
// 					disabled={!tempOption || href === '' || href.includes('undefined')}
// 				>
// 					Continuar
// 				</Submit>
// 			</a>
// 		</ModalContainer>
// 	</ShowModal>
// )
